import 'js-offcanvas/dist/_js/js-offcanvas.pkgd.min.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    var $primaryMenu = $('#menu-menu').clone();
    var $topMenu = $('#menu-topmenu').clone();
    var $logo = $('.brand').clone();

    $('#offCanvas').append($logo);
    $('#offCanvas').append($primaryMenu);
    $('#offCanvas').append($topMenu);

    $('#offCanvas').offcanvas({
      modifiers: 'right,reveal,shadow,shadow-left', // default options
    });

    $("#buy-tickets").stick_in_parent({
      offset_top: 0,
    });

    $("#checkout-cart").stick_in_parent({
      offset_top: 0,
    });

    // grab the price
    var initial_price = $('.tickets_price').attr('data-price');

    $('.cw_quantity_select select').on('change',function(){
       var price = initial_price * this.value;
       var total_price = '<span>Totaal:</span> &euro; ' + price.toFixed(2);
       $('.tickets_price_total').html(total_price);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js